<template>
    <v-btn
        v-if="!timeoutExpired"
        :absolute="absolute"
        :active-class="activeClass"
        :append="append"
        :block="block"
        :bottom="bottom"
        :color="color"
        :dark="dark"
        :depressed="depressed"
        :disabled="disabled"
        :exact="exact"
        :fab="fab"
        :fixed="fixed"
        :flat="flat"
        :href="href"
        :icon="icon || Boolean(iconName)"
        :input-value="inputValue"
        :id="id"
        :large="large"
        :left="left"
        :light="light"
        :loading="loading"
        :nuxt="nuxt"
        :outline="outline"
        :replace="replace"
        :right="right"
        :ripple="ripple"
        :round="round"
        :small="small"
        :tag="tag"
        :target="target"
        :to="to"
        :top="top"
        :type="type"
        :value="show"
        v-on="bindVOn"
        @click="handleButtonClick"
    >
        <v-icon
            v-if="iconName"
            v-text="iconName"
            :color="iconColor"
            :large="iconLarge"
            :left="iconLeft"
            :medium="iconMedium"
            :right="iconRight"
            :size="iconSize"
            :small="iconSmall"
            :x-large="iconXLarge"
        ></v-icon>
        <slot></slot>
    </v-btn>
</template>

<script>
    import WBtnMixin from '../../mixins/w-btn-mixin'
    import WTimeoutMixin from '../../mixins/w-timeout-mixin'

    /**
     * The w-btn component replaces the standard html button with a material design theme and a multitude of options.
     */
    export default {
        name: 'WBtn',
        mixins: [WBtnMixin, WTimeoutMixin]
    }

</script>
